import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-9xl mb-6" }, "404", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: "/",
      class: "text-lg hover:underline cursor-pointer mb-4"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Go to Home ")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/tx",
      class: "text-lg hover:underline cursor-pointer"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Search Transaction ")
      ]),
      _: 1
    })
  ]))
}